import useCrud from 'hooks/useCrud';
import { statistic } from 'services/api/phrase';

function useStatistic() {
  return useCrud({
    read: statistic,
  });
}

export default useStatistic;
